import {
  Flex,
  FlexBetween,
  FlexJustifyCenter,
  HubLengthMessage
} from '../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { AnimatedItem } from '../../../components/animation/AnimatedItem';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { USDT, formatUSD, showWallet } from '../../../helpers/helperFunctions';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { InvoiceHeader, InvoicesMobile, Invoices } from '../AccountingStyled';
import { Dispatch, SetStateAction } from 'react';

interface WithdrawalsPageType {
  withdrawals: any;
  countWithdrawals: number;
  setCountWithdrawals: Dispatch<SetStateAction<number>>;
}

export const WithdrawalsPage = ({
  withdrawals,
  countWithdrawals,
  setCountWithdrawals
}: WithdrawalsPageType) => {
  const { t } = useTranslation('accounting');

  const withdrawalStatus = (status: number) => {
    switch (status) {
      case 1:
        return t('pending');
      case 2:
        return t('paid');
      case 3:
        return t('completed');
      case 4:
        return t('canceled');
      case 5:
        return t('automatic_payout_in_progress');
      case 6:
        return t('paid');
      default:
    }
  };

  return (
    <AnimatedTab key={'WithdrawalsPage'}>
      <Desktop>
        <InvoiceHeader>
          <div style={{ width: '8%' }}>{t('date')}</div>
          <div style={{ width: '8%' }}>{t('id_withdrawal')}</div>
          <div style={{ width: '12.5%' }}>{t('amount')}</div>
          <div style={{ width: '12.5%' }}>{t('fee')}</div>
          <div style={{ width: '12.5%' }}>{t('paid_amount')}</div>
          <div style={{ width: '35%' }}>{t('wallet')}</div>
          <div style={{ width: '12.5%' }}>{t('status')}</div>
        </InvoiceHeader>
      </Desktop>

      {withdrawals?.length === 0 ? (
        <HubLengthMessage>{t('no_withdrawals')}</HubLengthMessage>
      ) : (
        withdrawals?.map((inv: any, i: number) => {
          return (
            <AnimatedItem index={i} key={i}>
              <Desktop>
                <Invoices>
                  <div style={{ width: '8%' }}>
                    {inv?.datePaid &&
                      moment.utc(inv?.datePaid).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '8%' }}>#{inv.id}</div>
                  <div style={{ width: '12.5%' }}>
                    {' '}
                    <span>
                      {formatUSD(inv.amount)}{' '}
                      {inv.networkCurrencyType.toUpperCase()}
                    </span>
                  </div>
                  <div style={{ width: '12.5%' }}>
                    <span>
                      {formatUSD(inv.feeAmount)}{' '}
                      {inv.networkCurrencyType.toUpperCase()}
                    </span>
                  </div>
                  <div style={{ width: '12.5%' }}>
                    <span>
                      {formatUSD(inv.paidAmount)}{' '}
                      {inv.networkCurrencyType.toUpperCase()}
                    </span>
                  </div>
                  <div style={{ width: '35%' }}>{inv.wallet}</div>

                  <div style={{ width: '12.5%' }}>
                    {withdrawalStatus(inv.status)}
                  </div>
                </Invoices>
              </Desktop>
              <Mobile>
                <Mobile>
                  <InvoicesMobile>
                    <FlexBetween>
                      <Flexed column>
                        <div>#{inv.id}</div>
                        <div>
                          {inv?.datePaid &&
                            moment.utc(inv?.datePaid).format('DD/MM/YY')}
                        </div>
                        <div
                          style={{
                            color: '#B5A8A8',
                            lineHeight: '18px',
                            fontSize: 12
                          }}>
                          {withdrawalStatus(inv.status)}
                        </div>
                      </Flexed>
                      <Flexed column alignEnd>
                        <div>
                          {formatUSD(inv.amount)} {USDT}
                        </div>

                        <div>
                          {formatUSD(inv.feeAmount)} {USDT}
                        </div>

                        <div>
                          {formatUSD(inv.paidAmount)} {USDT}
                        </div>
                      </Flexed>
                    </FlexBetween>

                    <Flex>
                      <div>{showWallet(inv.wallet, -30)}</div>
                    </Flex>
                  </InvoicesMobile>
                </Mobile>
              </Mobile>
            </AnimatedItem>
          );
        })
      )}
      {withdrawals?.length >= 50 &&
        withdrawals?.length === countWithdrawals && (
          <FlexJustifyCenter>
            <Button
              w='200px'
              mt='10'
              mb='20'
              onClick={() => setCountWithdrawals((count) => count + 50)}>
              {t('show_more')}
            </Button>
          </FlexJustifyCenter>
        )}
    </AnimatedTab>
  );
};
